import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { NgForm } from "@angular/forms";
import Swal from "sweetalert2";
import { AuthService } from "src/app/services/auth.service";
import { LoginModel } from "src/app/models/login.model";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { BackEndService } from "src/app/services/back-end.service";
import { NgxSpinnerService } from "ngx-spinner";
declare let $: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  // Properties

  // Nuevo Login
  public usuario: LoginModel = new LoginModel();
  public userData: any;
  public FormLogin: FormGroup;
  public token: string;
  public title: string;
  public status: string;
  public hidePassword = false;
  public hidePassword2 = false;
  public passEquals = false;
  public identity: object = { NOMBRE: "" };
  public dataUSer: any;
  public data: any;

  public objLogin = {
    usuario: "",
    contrasena: ""
  };

  FormPass: FormGroup;
  public objPass = {
    nueva_contrasena: "",
    confirmar_contrasena: "",
    tipo_documento: "",
    documento: "",
    id_pais: "",
    usuario: "",
    contrasena: ""
  };

  public year = new Date();
  public count: number;
  public dataObj = {};
  public dataWebContracts: any;

  // Params
  queryToken = "";

  constructor(
    private auth: AuthService,
    private readonly route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.FormLogin = new FormGroup({
      usuario: new FormControl("", [
        Validators.required,
        Validators.minLength(4)
      ]),
      contrasena: new FormControl("", [
        Validators.required,
        Validators.minLength(4)
      ])
    });

    this.FormLogin.setValue(this.objLogin);
  }

  ngOnInit() {
    setTimeout(() => {
      this.count = 1;
    }, 1000);
    this.auth.hide();

    if (localStorage.getItem("usuario")) {
      this.usuario.usuario = localStorage.getItem("usuario");
    }
    this.queryParams();
  }

  queryParams() {
    this.route.queryParamMap.subscribe(
      queryparams => {
        this.queryToken = queryparams.get("token_cambio");
      },
      (err: any) => {
        console.error(err);
      },
      () => {
        console.log("complete");
      }
    );
  }

  equals(form: NgForm) {
    const regExp = new RegExp(/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])\S{4,16}$/);
    if (
      this.objPass.confirmar_contrasena.match(regExp) &&
      this.objPass.nueva_contrasena.match(regExp) &&
      this.objPass.nueva_contrasena === this.objPass.confirmar_contrasena
    ) {
      this.passEquals = true;
    } else {
      this.passEquals = false;
    }
  }

  validate(form: NgForm) {
    if (this.passEquals === true && form.valid) {
      return true;
    } else {
      return false;
    }
  }

  login(form?: NgForm, dataLogin?: object) {
    if (dataLogin) {
      this.FormLogin.setValue(dataLogin);
    }

    (window as any).gtag("event", "login", {
      event_category: "prelogin",
      event_label: ""
    });

    if (form && form.invalid) {
      return;
    }

    Swal.fire({
      allowOutsideClick: false,
      type: "info",
      text: "Espere por favor..."
    });
    Swal.showLoading();

    this.auth.login(this.FormLogin.value).subscribe(
      (resp: any) => {
        if (!resp && !resp.v_nombre_1) {
          return Swal.fire({
            allowOutsideClick: false,
            type: "error",
            text: "Por favor intente más tarde."
          });
        }

        if (resp && resp.CONSULTA_USUARIOS_REGISTRO[0].v_tipo_usuario === "0") {
          Swal.fire({
            allowOutsideClick: false,
            type: "error",
            title: "Usuario no autorizado."
          });
          setTimeout(() => {
            localStorage.clear();
          }, 1000);
          return;
        }

        this.data = resp.CONSULTA_USUARIOS_REGISTRO[0];
        this.dataUSer = {
          id_pais: 1,
          id_pais_af: 1,
          tipo_documento: this.data.v_tipo_documento,
          documento: this.data.v_documento,
          tipo_documento_af: this.data.v_tipo_documento,
          documento_af: this.data.v_documento
        };

        // Renovar Password
        if (resp && resp.actualiza_contrasena === true) {
          Swal.close();
          $("#modalUpdatePasswordUser").modal("show");
          this.identity = resp;
          const response = resp.CONSULTA_USUARIOS_REGISTRO[0];
          this.objPass.tipo_documento = response.v_tipo_documento;
          this.objPass.documento = response.v_documento;
          this.objPass.id_pais = response.v_pais;
          this.objPass.usuario = response.v_usuario;

          // Persistir Datos
          localStorage.setItem(
            "identityCVE",
            JSON.stringify(resp.CONSULTA_USUARIOS_REGISTRO[0])
          );
          // Acceder a dataObj de usuario
          this.userData = JSON.parse(localStorage.getItem("identityCVE"));

          return;
        } else {
          this.identity = resp;
          // Validar si el usuario tiene contratos activos
          this.webContracts(this.dataUSer);
          Swal.close();
          // Persistir Datos
          localStorage.setItem(
            "identityCVE",
            JSON.stringify(resp.CONSULTA_USUARIOS_REGISTRO[0])
          );
          // Acceder a dataObj de usuario
          this.userData = JSON.parse(localStorage.getItem("identityCVE"));
        }
      },
      err => {
        (window as any).gtag("event", "no entró", {
          event_category: "prelogin",
          event_label: ""
        });
        console.log("error en login", err);
        const errorMessage = $(err.error)
          .last()
          .text();
        Swal.fire({
          type: "error",
          // title: 'Error al autenticar',
          title: "Alerta:",
          text: errorMessage
        });
      }
    );
  }

  notEqual(control: FormControl): { [s: string]: boolean } {
    const formpass: any = this;
    if (control.value !== formpass.controls["nueva_contrasena"].value) {
      return {
        noiguales: true
      };
    }
    return null;
  }

  confirmPassword(form: NgForm) {
    this.objPass.nueva_contrasena = encodeURIComponent(
      this.objPass.nueva_contrasena
    );
    this.objPass.confirmar_contrasena = encodeURIComponent(
      this.objPass.confirmar_contrasena
    );
    this.objPass.contrasena = this.objPass.nueva_contrasena;
    delete this.objPass.confirmar_contrasena;
    delete this.objPass.nueva_contrasena;

    if (form.invalid) {
      return;
    }

    Swal.fire({
      allowOutsideClick: false,
      type: "info",
      text: "Espere por favor..."
    });

    Swal.showLoading();

    this.auth.updatePass(this.objPass).subscribe(
      (resp: any) => {
        $("#modalUpdatePasswordUser").modal("hide");
        Swal.close();
        if (resp && resp.ACTUALIZA_CONTRASENA_USUARIOS[0].mensaje === "OK") {
          Swal.fire({
            allowOutsideClick: false,
            type: "success",
            text: "¡Contraseña actualizada!",
            timer: 1500
          });
          // this.router.navigateByUrl('/carga');
          this.webContracts(this.dataUSer);
        } else {
          this.router.navigateByUrl("/login");
        }
      },
      err => {
        $("#modalUpdatePasswordUser").modal("hide");
        console.log("error", err);
        Swal.close();
        Swal.fire({
          type: "error",
          title: "Error al cambiar contraseña",
          text: "Error de contraseña"
        });
      }
    );
  }

  webContracts(data: any) {
    this.auth.getWebContracts(data).subscribe(
      (resp: any) => {
        const response = resp.CONSULTA_CONTRATOS_WEB;
        this.dataWebContracts = response.filter(
          (contrato: any) => contrato.estado === "A" || contrato.estado === "S"
        );
        if (this.dataWebContracts.length > 0) {
          if (this.userData != null) {
            this.toastNotification(
              "",
              "¡Bienvendid@ " + this.userData.v_usuario + "!"
            );
          }
          this.router.navigateByUrl("/carga");
          this.router
            .navigateByUrl("/RefrshComponent", { skipLocationChange: true })
            .then(() => this.router.navigate(["carga"]));
        } else {
          localStorage.clear();
          setTimeout(() => {
            Swal.fire({
              type: "error",
              title: "Alerta",
              text: "No tiene contratos activos."
            });
          }, 1000);
        }
      },
      (err: any) => {
        console.error(err);
        this.dataWebContracts = [];
        return false;
      }
    );
  }


  showTabDatos() {
    $("#dataObj-tab").tab("show");
  }

  showTabPoliticas() {
    $("#politica-tab").tab("show");
  }

  showTabTerminos() {
    $("#terminos-tab").tab("show");
  }

  togglePassword() {
    this.hidePassword = !this.hidePassword;
  }

  togglePassword2() {
    this.hidePassword2 = !this.hidePassword2;
  }

  toastNotification(titulo: string, descripcion: string) {
    this.toastr.success(titulo, descripcion);
  }
}
